import { store } from 'store';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { CONTAINERS_LIST } from 'shared/enums';
import { setSelectedContainerAction } from 'modules/mainNavigation/actions';
import { ITab, ITabProps } from 'interfaces/utils';
import { AsyncThunkAction } from '@reduxjs/toolkit';

const containerPermissionList = [
  CONTAINERS_LIST.EPS,
  CONTAINERS_LIST.REMUNERATION,
  CONTAINERS_LIST.MAILING,
  CONTAINERS_LIST.SETTINGS,
];

export const containersPermissionByUserPermissions = (permissions: {
  [key: string]: boolean;
}): { [key: string]: boolean } => {
  return containerPermissionList.reduce((total, current) => {
    const hasPermission = permissions[current];

    if (!hasPermission) {
      return total;
    }
    return Object.assign(total, { [current]: permissions[current] });
  }, {});
};

export const containersPermission = (): { [key: string]: boolean } => {
  const { permissions, loading } = store.getState().user;
  if (loading !== REQUEST_LIFE_CICLE.SUCCEEDED) {
    return {};
  }

  return containersPermissionByUserPermissions(permissions);
};

const getFirstContainerAvailable = (): string => {
  const { loading } = store.getState().user;
  if (loading !== REQUEST_LIFE_CICLE.SUCCEEDED) {
    return '';
  }

  return Object.keys(containersPermission())[0];
};

export const setFirstContainerAvailable = async (): Promise<void> => {
  const { loading } = store.getState().user;

  if (loading !== REQUEST_LIFE_CICLE.SUCCEEDED) {
    return;
  }

  const { mainNavigation } = store.getState();

  const firstContainer = getFirstContainerAvailable();

  const menuSelected = !firstContainer
    ? CONTAINERS_LIST.NO_CAR_OI_ACCESS
    : mainNavigation !== CONTAINERS_LIST.EPS
    ? mainNavigation
    : firstContainer;

  await store.dispatch(
    setSelectedContainerAction(menuSelected as CONTAINERS_LIST),
  );
};

export const setMainNavigationContainerByUserPermission = async (permissions: {
  [key: string]: boolean;
}): Promise<void> => {
  const { mainNavigation } = store.getState();

  const firstContainer = Object.keys(
    containersPermissionByUserPermissions(permissions),
  )[0];

  const menuSelected = !firstContainer
    ? CONTAINERS_LIST.NO_CAR_OI_ACCESS
    : mainNavigation !== CONTAINERS_LIST.EPS
    ? mainNavigation
    : firstContainer;

  await store.dispatch(
    setSelectedContainerAction(menuSelected as CONTAINERS_LIST),
  );
};

export const setFirstSubContainerAvailable = async ({
  tabsEntries,
  currentTab,
  defaultTab,
  setNavigationAction,
}: {
  tabsEntries: [string, ITab][];
  currentTab: string;
  defaultTab: string;
  setNavigationAction(
    value: string,
  ): AsyncThunkAction<string, string, { rejectValue: IMyKnownError }>;
}): Promise<void> => {
  const { permissions, loading } = store.getState().user;

  if (loading !== REQUEST_LIFE_CICLE.SUCCEEDED) {
    return;
  }
  const activeTabsByPermission = tabsEntries.filter(
    (tab) => permissions[`${tab[1].key}`],
  );

  const initialTabMode = activeTabsByPermission[0][0];

  if (initialTabMode !== defaultTab) {
    const tabSelected = currentTab !== defaultTab ? currentTab : initialTabMode;
    await store.dispatch(setNavigationAction(tabSelected));
  }
};

export const setSubContainerTabsProps = ({
  tabsEntries,
  setActivetedTabsProps,
}: {
  tabsEntries: [string, ITab][];
  setActivetedTabsProps(values: ITabProps[]): void;
}): void => {
  const { permissions, loading } = store.getState().user;

  if (loading !== REQUEST_LIFE_CICLE.SUCCEEDED) {
    return;
  }

  const activeTabsByPermission = tabsEntries.filter((tab) => {
    return permissions[`${tab[1].permission || tab[1].key}`];
  });
  const activetedTabsProps: ITabProps[] = activeTabsByPermission.map((tab) => {
    const key = tab[0];
    const values = tab[1];
    return { key: values.key, label: values.label, value: key } as ITabProps;
  });
  setActivetedTabsProps(activetedTabsProps);
};
